import {
  CorporateContactJsonLd,
  DefaultSeo,
  EventJsonLd,
  LogoJsonLd,
  OrganizationJsonLd,
  SiteLinksSearchBoxJsonLd,
} from 'next-seo';
import { useRouter } from 'next/router';

import { canonize, toAbsoluteLink } from 'lib/links';

import SEO from '../../../next-seo.config';

import APP from 'constants/app';
import LINKS from 'constants/links';

const EVENTS = [
  {
    name: 'Black Friday 2025',
    description:
      'A contagem regressiva começou! A Black Friday 2025 é o evento mais esperado do ano por quem quer economizar de verdade — e no Promobit você encontra as melhores ofertas da internet, todas verificadas por uma comunidade ativa de milhares de usuários.',
    landingUrl: LINKS.BLACK_FRIDAY,
    startDate: new Date('2025-10-17T00:00-03:00'),
    endDate: new Date('2025-11-30T23:59-03:00'),
  },
  {
    name: 'Natal 2025',
    description:
      'O espírito natalino chegou com tudo no Promobit! O Natal 2025 é o momento ideal para garantir os melhores presentes com descontos reais e ofertas verificadas pela comunidade. Durante esse grande evento, você encontra promoções especiais de Natal em eletrônicos, brinquedos, celulares, roupas, decoração, perfumes, livros, itens de cozinha e muito mais — tudo com preços que cabem no seu bolso.',
    landingUrl: LINKS.CHRISTMAS,
    startDate: new Date('2025-12-25T00:00-03:00'),
    endDate: new Date('2025-12-25T23:59-03:00'),
  },
  {
    name: 'Dia dos Pais 2025',
    description:
      'O Dia dos Pais 2025 está chegando, e o Promobit preparou um verdadeiro evento de ofertas para ajudar você a encontrar o presente ideal para o seu pai com descontos de verdade!',
    landingUrl: LINKS.FATHERS_DAY,
    startDate: new Date('2025-08-09T00:00-03:00'),
    endDate: new Date('2025-08-09T23:59-03:00'),
  },
  {
    name: 'Dia das Mães 2026',
    description:
      'O Dia das Mães 2026 está chegando, e o Promobit preparou um evento exclusivo com ofertas incríveis para você presentear com amor e economia. Celebre quem sempre esteve ao seu lado: participe do evento de Dia das Mães no Promobit e faça dessa data um momento ainda mais especial — com carinho, escolha e economia.',
    landingUrl: LINKS.MOTHERS_DAY,
    startDate: new Date('2025-05-10T00:00-03:00'),
    endDate: new Date('2025-05-10T23:59-03:00'),
  },
  {
    name: 'Ano Novo 2026',
    description:
      'A virada do ano é o momento perfeito para renovar, planejar e aproveitar oportunidades — e no Promobit, o Ano Novo 2026 é celebrado com um grande evento de ofertas exclusivas e descontos reais para você começar o ano economizando de verdade. Seja para presentear, renovar a casa, cuidar de você ou investir em novos planos, o Promobit é o lugar certo para aproveitar o início de 2026 com inteligência e economia.',
    landingUrl: LINKS.HAPPY_NEW_YEAR,
    startDate: new Date('2026-01-01T00:00-03:00'),
    endDate: new Date('2026-01-01T23:59-03:00'),
  },
  {
    name: 'Prime Day 2026',
    description:
      'Descubra as melhores ofertas do Amazon Prime Day 2026 no Promobit! Acompanhe em tempo real os maiores descontos em eletrônicos, games, eletrodomésticos, moda e muito mais. Reunimos as promoções mais quentes validadas pela nossa comunidade para você economizar de verdade. Prepare sua lista de desejos e aproveite os dias mais esperados do ano para comprar barato na Amazon Brasil com o Promobit ao seu lado!',
    landingUrl: LINKS.PRIME_DAY,
    startDate: new Date('2026-07-15T00:00-03:00'),
    endDate: new Date('2026-07-16T23:59-03:00'),
  },
];

const UniversalSchemas = () => {
  const { asPath } = useRouter();

  const url = canonize(asPath);

  return (
    <>
      <DefaultSeo
        {...SEO}
        canonical={url}
        openGraph={{ ...SEO.openGraph, url }}
      />
      <LogoJsonLd
        logo={toAbsoluteLink`${APP.LOCAL_IMAGE_PATH}/features/topbar/promobit-logo.svg`}
        url={APP.URL}
      />
      <OrganizationJsonLd
        address={{
          streetAddress: APP.ADDRESS.STREET,
          addressLocality: APP.ADDRESS.CITY,
          addressRegion: APP.ADDRESS.ACRONYM_STATE,
          postalCode: APP.ADDRESS.POSTAL_CODE,
          addressCountry: APP.ADDRESS.ACRONYM_COUNTRY,
        }}
        contactPoint={{
          contactType: 'customer service',
          email: APP.COMMERCIAL_EMAIL,
          areaServed: 'BR',
          availableLanguage: ['Portuguese'],
        }}
        legalName={APP.LEGAL_NAME}
        logo={toAbsoluteLink(
          `${APP.LOCAL_IMAGE_PATH}/features/topbar/promobit-logo.svg`
        )}
        name={APP.NAME}
        type="organization"
        url={APP.URL}
      />
      <SiteLinksSearchBoxJsonLd
        potentialActions={[
          {
            target: 'https://promobit.com.br/buscar?q={search_term_string}',
            queryInput: 'required name=search_term_string',
          },
        ]}
        url={APP.URL}
      />
      {EVENTS.map(({ description, endDate, landingUrl, name, startDate }) => (
        <EventJsonLd
          key={name}
          description={description}
          endDate={endDate.toISOString()}
          location={{
            '@type': 'Place',
            name: 'Online',
            url: toAbsoluteLink(`/${landingUrl}`),
          }}
          name={name}
          organizer={{
            '@type': 'Organization',
            name: 'Promobit',
            url: APP.URL,
          }}
          startDate={startDate.toISOString()}
        />
      ))}
      <CorporateContactJsonLd
        contactPoint={[
          {
            contactType: 'customer service',
            email: APP.COMMERCIAL_EMAIL,
            areaServed: 'BR',
            availableLanguage: ['Portuguese'],
          },
        ]}
        logo={toAbsoluteLink(
          `${APP.LOCAL_IMAGE_PATH}/features/topbar/promobit-logo.svg`
        )}
        url={APP.URL}
      />
    </>
  );
};

export default UniversalSchemas;
